const initMainProductTabsDetails = () => {
    const stickyEl = document.querySelector('.product__info-wrapper');
    const stopEl = document.querySelector('footer');
    if (!stickyEl || !stopEl) return;

    const headerHeight = 150;
    const stickyStart = stickyEl.offsetTop; 

    function getStopPoint() {
      return stopEl.getBoundingClientRect().top + window.scrollY;
    }

    function updateSticky() {
      const scrollTop = window.scrollY;
      const stickyHeight = stickyEl.offsetHeight;
      const parentWidth = stickyEl.parentElement.offsetWidth;
      const stopPoint = getStopPoint();
      const padding = window.innerWidth > 1180 ? 80 : 15;

      if (window.innerWidth <= 1025) {
        stickyEl.style.position = 'relative';
        stickyEl.style.top = 'unset';
        stickyEl.style.width = '100%';
        stickyEl.style.left = 'unset';
        return;
      }

      if (scrollTop + headerHeight + stickyHeight >= stopPoint) {
        stickyEl.style.position = 'absolute';
        stickyEl.style.top = stopPoint - stickyHeight + 'px';
        stickyEl.style.width = parentWidth * 0.4 + 'px';
        stickyEl.style.left = parentWidth - parentWidth * 0.4 + padding + 'px';
      } else if (scrollTop >= stickyStart - headerHeight) {
        stickyEl.style.position = 'fixed';
        stickyEl.style.top = headerHeight + 'px';
        stickyEl.style.width = parentWidth * 0.4 + 'px';
        stickyEl.style.left = parentWidth - parentWidth * 0.4 + padding - 12 + 'px';
      } else {
        stickyEl.style.position = 'relative';
        stickyEl.style.top = 'unset';
        stickyEl.style.width = parentWidth * 0.4 + 'px';
        stickyEl.style.left = 'unset';
      }
    }

    window.addEventListener('scroll', updateSticky);
    updateSticky();

    const imageContainer = document.querySelector('.pdp-description-images');
    if (!imageContainer) return;

    function isMobile() { return window.matchMedia('(max-width: 1024px)').matches; }
    function getInitialHeight() { return isMobile() ? '300px' : '500px'; }

    let isCollapsed = true;

    imageContainer.style.position = 'relative';
    imageContainer.style.overflow = 'hidden';
    imageContainer.style.maxHeight = getInitialHeight();
    imageContainer.style.transition = 'max-height 0.4s ease';

    // 더보기 버튼 생성
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'toggle-images-btn';
    
    const getButtonIcon = (isExpanded) => {
      const rotate = isExpanded ? 'style="transform:rotate(180deg)"' : '';
      const size = isMobile() ? 16 : 24;
      return `
        <button type="button">
          <span>제품 상세 ${isExpanded ? '접기' : '더보기'}</span>
          <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ${rotate}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8423 9.15566C19.0526 9.3632 19.0526 9.69969 18.8423 9.90724L13.1422 15.533C12.5114 16.1557 11.4886 16.1557 10.8577 15.533L5.1577 9.90724C4.9474 9.69969 4.9474 9.3632 5.1577 9.15566C5.368 8.94811 5.7089 8.94811 5.9192 9.15566L11.6192 14.7814C11.8295 14.989 12.1705 14.989 12.3807 14.7814L18.0808 9.15566C18.2911 8.94811 18.632 8.94811 18.8423 9.15566Z" fill="#171719"/>
          </svg>
        </button>`;
    };

    buttonContainer.innerHTML = getButtonIcon(false);
    imageContainer.appendChild(buttonContainer);

    const descriptionContainer = document.querySelector('.pdp-description-images');
    if (!descriptionContainer) return;
    const images = descriptionContainer.querySelectorAll('img');
    if (images.length === 0) return;


    const mask = document.createElement('div');
    mask.className = 'mobile-mask';
    mask.style.cssText = `
        height: 40px;
        background-color: #fff;
        bottom: 30px;
        position: relative;
        margin-left: -5px;
        margin-right: -5px;
        display: ${isMobile() ? 'block' : 'none'};
    `;
    descriptionContainer.after(mask);

    // 클릭 이벤트
    buttonContainer.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;

      isCollapsed = !isCollapsed;

      if (isCollapsed) {
        // 접기
        const productDesc = document.querySelector('.product-description.page-width');
        const scrollTarget = productDesc ? productDesc.offsetTop - headerHeight - 80 : 0;
        
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });

        setTimeout(() => {
          imageContainer.classList.remove('expanded'); 
          buttonContainer.classList.remove('expanded');
          imageContainer.style.maxHeight = getInitialHeight();
          buttonContainer.innerHTML = getButtonIcon(false);
          mask.style.display = isMobile() ? 'block' : 'none';
        }, 300);
      } else {
        // 더보기
        imageContainer.classList.add('expanded');
        buttonContainer.classList.add('expanded');
        imageContainer.style.maxHeight = imageContainer.scrollHeight + 'px';
        buttonContainer.innerHTML = getButtonIcon(true);
        mask.style.display = 'none';
      }

      // Sticky 위치 업데이트
      if (!isMobile()) {
        setTimeout(() => {
          updateSticky();
          window.dispatchEvent(new Event('scroll'));
        }, 450);
      }
    });

    // 리사이즈 처리
    window.addEventListener('resize', throttle(() => {
      updateSticky();
      if (isCollapsed) imageContainer.style.maxHeight = getInitialHeight();
      mask.style.display = (isMobile() && isCollapsed) ? 'block' : 'none';
    }, 150));
  };


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMainProductTabsDetails, { once: true });
} else {
  initMainProductTabsDetails();
}